import useSWR, { SWRConfiguration } from 'swr';

import { fetchFromNewApi } from '~/services/Http';
import { APIs } from '~/services/Http/internalAPIs';
import { FormioFormBuilderConfig } from '~/types/forms';

export const useFormTemplateDetails = (
  templateId: string,
  swrConfig?: SWRConfiguration,
) => {
  return useSWR<FormioFormBuilderConfig>(
    ['formsTemplateDetails', templateId],
    ([_key, templateId]) =>
      fetchFromNewApi(APIs.forms.formGeneral(templateId), {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
      }).then((r) => r.json()),
    { revalidateOnFocus: false, ...swrConfig },
  );
};
